import React from 'react';
import { Route, Routes } from 'react-router-dom';
import OperationsMainLanding from '../modules/ops/pages/OperationsMainLanding';
import Quotes from '../modules/finance/pages/Quotes';
import QuoteDetail from '../modules/finance/pages/QuoteDetail';
import PPMLanding from '../PPMLanding';
import StockLanding from '../StockLanding';
import StockAdjustments from '../modules/ops/pages/StockAdjustments';
import StockTransfers from '../modules/ops/pages/StockTransfers';
import PurchaseOrders from '../PurchaseOrders';
import PurchaseOrdersDashboard from '../PurchaseOrdersDashboard';
import PurchaseOrderNew from '../PurchaseOrderNew';
import PurchaseOrderDetail from '../PurchaseOrderDetail';
import Suppliers from '../modules/ops/pages/Suppliers';
import Employees from '../Employees';
import EmployeeDetail from '../EmployeeDetail';
import SupplierDetail from '../modules/ops/pages/SupplierDetail';
import Jobs from '../modules/ops/pages/Jobs';
import JobDetail from '../modules/ops/pages/JobDetail';
import UnassignedJobs from '../UnassignedJobs';
import KestrelCuts from '../modules/door_draw/src/pages/KestrelCuts';
import DailyPlanningLanding from '../DailyPlanningLanding';
import EngineerDispatch from '../EngineerDispatch';
import EngineerAppOffice from '../EngineerAppOffice';
import FleetTracking from '../FleetTracking';
import DispatchLanding from '../DispatchLanding';
import SalesOrders from '../modules/crm/pages/SalesOrders';

import InventoryLanding from '../modules/ops/pages/InventoryLanding';
import Warehouses from '../modules/ops/pages/Warehouses';
import WarehouseDetail from '../modules/ops/pages/WarehouseDetail';
import StockLevels from '../modules/ops/pages/StockLevels';

import Products from '../Products';
import ProductDetail from '../ProductDetail';
import LabourCosts from '../LabourCosts';
import LabourCostDetail from '../LabourCostDetail';
import Consumables from '../Consumables';
import ConsumableDetail from '../ConsumableDetail';

const OpsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<OperationsMainLanding />} />
      <Route path="ppm" element={<PPMLanding />} />
      <Route path="stock" element={<StockLanding />} />
      <Route path="inventory" element={<InventoryLanding />} />
      <Route path="inventory-landing" element={<InventoryLanding />} />
      <Route path="warehouses" element={<Warehouses />} />
      <Route path="warehouse/:id" element={<WarehouseDetail />} />
      <Route path="stock-levels" element={<StockLevels />} />
      <Route path="stock-adjustments" element={<StockAdjustments />} />
      <Route path="stock-transfers" element={<StockTransfers />} />
      <Route path="purchase-orders" element={<PurchaseOrders />} />
      <Route path="purchase-orders/dashboard" element={<PurchaseOrdersDashboard />} />
      <Route path="purchase-orders/new" element={<PurchaseOrderNew />} />
      <Route path="purchase-orders/:id" element={<PurchaseOrderDetail />} />
      <Route path="suppliers" element={<Suppliers />} />
      <Route path="employees" element={<Employees />} />
      <Route path="employees/:id" element={<EmployeeDetail />} />
      <Route path="suppliers/:id" element={<SupplierDetail />} />
      <Route path="jobs" element={<Jobs />} />
      <Route path="sales-orders" element={<SalesOrders />} />
      <Route path="jobs/:id" element={<JobDetail />} />
      <Route path="jobs/unassigned" element={<UnassignedJobs />} />
      <Route path="quotes" element={<Quotes />} />
      <Route path="quotes/:id" element={<QuoteDetail />} />
      <Route path="daily-planning" element={<DailyPlanningLanding />} />
      <Route path="engineer-dispatch" element={<EngineerDispatch />} />
      <Route path="engineer-app" element={<EngineerAppOffice />} />
      <Route path="fleet-tracking" element={<FleetTracking />} />
      <Route path="dispatch" element={<DispatchLanding />} />
      <Route path="products" element={<Products />} />
      <Route path="products/:id" element={<ProductDetail />} />
      <Route path="labour-costs" element={<LabourCosts />} />
      <Route path="labour-costs/:id" element={<LabourCostDetail />} />
      <Route path="consumables" element={<Consumables />} />
      <Route path="consumables/:id" element={<ConsumableDetail />} />
    </Routes>
  );
};

export default OpsRoutes;
